import { MouseEvent } from "react";
import { styled } from "styled-components";
import { Typography } from "components/typography";

// It's hard to modify single rows in our table. ProgramTreatmentCellText
// is the cell with the highest height in the row, so this margin trick forces
// the whole row to take a bit more space between rows.
const ClickableWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  width: fit-content;
  cursor: pointer;
  min-width: 150px;
  p {
    text-decoration: none;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface Props {
  programName: string;
  treatmentName: string;
  handleClickProgramTitle?: () => void;
  sortKey?: string | number;
  children?: React.ReactNode;
}

export const ProgramTreatmentCellText = ({
  programName,
  treatmentName,
  handleClickProgramTitle,
  children,
}: Props) => {
  const onClick = (event: MouseEvent<HTMLDivElement>) => {
    if (handleClickProgramTitle) {
      event.stopPropagation();
      handleClickProgramTitle();
    }
  };

  return (
    <ClickableWrapper onClick={onClick}>
      <Column>
        <div>
          <Typography variant="body" color="GRAY_BLACK">
            {programName}
          </Typography>
          <Typography variant="body-small" color="GRAY_DARK">
            {treatmentName}
          </Typography>
        </div>
        {children}
      </Column>
    </ClickableWrapper>
  );
};
